import React, { useRef, useEffect } from 'react';
import ChatMessage from './ChatMessage';
import './Chat.css';

export default function MessageList({
  messages,
  users,
  currentUserId,
  onReply,
  highlightMessageIds = [],
  scrollToHighlighted = false,
}) {
  const listRef = useRef(null);
  const highlightRefs = useRef({});

  useEffect(() => {
    if (!listRef.current) return;
    listRef.current.scrollTop = listRef.current.scrollHeight;
  }, [messages]);

  useEffect(() => {
    if (!scrollToHighlighted || highlightMessageIds.length === 0) return;
    const firstId = highlightMessageIds[0];
    const el = highlightRefs.current[firstId];
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [scrollToHighlighted, highlightMessageIds]);

  const getUser = (userId) => users.find((u) => String(u.id) === String(userId));
  const getReplyTo = (replyToId) => {
    const msg = messages.find((m) => m.id === replyToId);
    return msg ? { ...msg, user: getUser(msg.userId) } : null;
  };

  return (
    <div ref={listRef} className="chat-message-list">
      {messages.length === 0 ? (
        <div className="chat-message-list-empty">No messages yet. Start the conversation.</div>
      ) : (
        messages.map((msg, index) => (
          <div
            key={`msg-${msg.id ?? 'n'}-${index}`}
            ref={(el) => { highlightRefs.current[msg.id] = el; }}
            className={`chat-message-row ${highlightMessageIds.includes(msg.id) ? 'chat-message-row--mentioned' : ''}`}
          >
            <ChatMessage
              message={msg}
              replyToMessage={msg.replyToId ? getReplyTo(msg.replyToId) : null}
              user={getUser(msg.userId)}
              currentUserId={currentUserId}
              isMentioned={highlightMessageIds.includes(msg.id)}
            />
            <button
              type="button"
              className="chat-reply-btn"
              onClick={() => onReply(msg)}
            >
              Reply
            </button>
          </div>
        ))
      )}
    </div>
  );
}
